import React from 'react';

const CelebratingAchievements = () => {
  return (
    <section id="achivement" className="achivement section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Celebrating Our Achievements</h2>
        <p><span>Recognitions & </span> <span className="description-title">Achievements</span></p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="200">
        <div className="row gy-3">
          <div className="col-md-9 mx-auto">
            <div className="row">
              <div className="col-6 col-lg-4 menu-item">
                <img src="/assets/img/awards/NAAC_finalacc.jpg" className="menu-img img-fluid" alt="NAAC Accreditation" />
              </div>
              <div className="col-6 col-lg-4 menu-item">
                <img src="/assets/img/awards/dr-Sarvepalli-award.jpg" className="menu-img img-fluid" alt="Dr. Sarvepalli Award" />
              </div>
              <div className="col-6 col-lg-4 menu-item">
                <img src="/assets/img/awards/savitriphule-award.jpg" className="menu-img img-fluid" alt="Savitri Phule Award" />
              </div>
              <div className="col-6 col-lg-4 menu-item">
                <img src="/assets/img/awards/structural-award.jpg" className="menu-img img-fluid" alt="Structural Award" />
              </div>
              <div className="col-6 col-lg-4 menu-item">
                <img src="/assets/img/awards/international-iconic-award.jpg" className="menu-img img-fluid" alt="International Iconic Award" />
              </div>
              <div className="col-6 col-lg-4 menu-item">
                <img src="/assets/img/awards/iirf-award.jpg" className="menu-img img-fluid" alt="IIRF Award" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CelebratingAchievements;
